import React from 'react'
import SubjectForm from './SubjectForm'
import {Modal} from 'react-bootstrap'


const SubjectNew = ({show,handleModalClose,handleSubmit,subject,icons}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Neues Fach</Modal.Title>
        </Modal.Header>
          <SubjectForm
             handleSubmit={handleSubmit} icons={icons}
            />
        </Modal>
  </div>
)

export default SubjectNew
